<!-- 国际销售代理 -->
<template>
  <div class="Trailer bg-round bg-fff">
    <div class="container">
      <Bread :list="breadList" class="ma-t-10" />
      <div class="flex f-between ma-t-30">
        <div class="width70">
          <div class="flex f-wrap width100">
            <div
              class="t-center img-item ma-b-30"
              v-for="(item, index) in dataList"
              :key="index"
              @click="
                $router.push({ path: '/preview/detail', query: { id: item.Id } })
              "
            >
              <img
                :src="item.Image"
                alt=""
                srcset=""
                height="220px"
                width="100%"
                class="img_cover b-r-10"
              />
              <div class="t-omit-1 ma-t-10">{{ item.Name }}</div>
            </div>
          </div>
          <Empty :isShow="!dataList || dataList.length == 0"></Empty>
          <div class="fy t-center">
            <el-pagination
              @current-change="handleCurrentChange"
              :hide-on-single-page="true"
              :current-page.sync="pageIndex"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="totals"
            ></el-pagination>
          </div>
        </div>

        <div class="width30 pa-l-20 box-s-b-b">
          <div class="menu-item fon-24">
            <div class="font-bold">找电影</div>
            <div class="font-bold">Find a movie</div>
            <img
              src="../img/index/index21(1).png"
              class="item-right"
              alt=""
              srcset=""
            />
            <img
              src="../img/index/index22.png"
              class="item-left"
              alt=""
              srcset=""
            />
          </div>

          <div class="ma-t-30">
            <div class="search-input">
              <el-input placeholder="电影名称" v-model="name">
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="loadDataList('refresh')"
                ></i>
              </el-input>
            </div>

            <div class="font-bold ma-t-30">类型：</div>
            <div class="flex f-wrap">
              <div
                class="search-item"
                :class="{ 'font-bold c-red': categoryId == 0 }"
                @click="
                  categoryId = 0;
                  loadDataList('refresh');
                "
              >
                全部
              </div>

              <div
                class="search-item"
                v-for="(item, index) in categoryList"
                :key="index"
                :class="{ 'font-bold c-red': categoryId == item.Id }"
                @click="
                  categoryId = item.Id;
                  loadDataList('refresh');
                "
              >
                {{ item.Name }}
              </div>
            </div>

            <div class="font-bold ma-t-30">地区：</div>
            <div class="flex f-wrap">
              <div
                class="search-item"
                v-for="(item, index) in areaList"
                :key="index"
                :class="{ 'font-bold c-red': area == item.id }"
                @click="
                  area = item.id;
                  loadDataList('refresh');
                "
              >
                {{ item.name }}
              </div>
            </div>

            <div class="font-bold ma-t-30">年代：</div>
            <div class="flex f-wrap">
              <div
                class="search-item"
                :class="{ 'c-red font-bold': age == 0 }"
                @click="
                  age = 0;
                  loadDataList('refresh');
                "
              >
                全部
              </div>

              <div
                v-for="(item, index) in 7"
                :key="index"
                class="search-item"
                :class="{
                  'c-red font-bold': age == new Date().getFullYear() - index,
                }"
                @click="
                  age = new Date().getFullYear() - index;
                  loadDataList('refresh');
                "
              >
                {{ new Date().getFullYear() - index }}
              </div>
              <div
                class="search-item"
                :class="{ 'c-red font-bold': age == -1 }"
                @click="
                  age = -1;
                  loadDataList('refresh');
                "
              >
                {{ new Date().getFullYear() - 7 }}-更早
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bread from "../components/Bread.vue";
import { getTrailerCategory, getTrailerList } from "../api.js";
export default {
  components: {
    Bread,
  },
  data() {
    return {
      breadList: [
        {
          name: "国际销售代理",
          path: "/preview/index",
        },
      ],
      totals: 0, //一个分类下的总条数
      pageIndex: 1,
      pageSize: 16,
      categoryId: 0,
      dataList: [],
      categoryList: [],
      //1: 内地;2: 中国香港:3: 中国台湾:4: 韩国;5: 美国;6: 英国;7: 日本;8: 泰国:
      areaList: [
        { id: 0, name: "全部" },
        { id: 1, name: "内地" },
        { id: 2, name: "中国香港" },
        { id: 3, name: "中国台湾" },
        { id: 4, name: "韩国" },
        { id: 5, name: "美国" },
        { id: 6, name: "英国" },
        { id: 7, name: "日本" },
        { id: 8, name: "泰国" },
      ],
      age: 0, //年代
      area: 0, //地区
      name: "", //电影名称
    };
  },
  created() {
    this.loadData();
    this.loadDataList();
  },
  methods: {
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.loadDataList();
    },
    loadData() {
      getTrailerCategory().then((res) => {
        this.categoryList = res.data.Data;
      });
    },
    //获取列表数据
    loadDataList(type) {
      if (type == "refresh") {
        this.pageIndex = 1;
      }
      getTrailerList({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        categoryId: this.categoryId,
        areas: this.area,
        age: this.age,
        name: this.name,
      }).then((res) => {
        this.dataList = res.data.Data.List;
        this.totals=res.data.Data.TotalCount
      });
    },
  },
};
</script>

<style scoped lang="scss">
.Trailer .container {
  min-height: 1150px;
  // background: #ffffff;
  box-sizing: border-box;
  padding: 30px 0;
}
.img-item {
  width: 20%;
}
.img-item:not(:nth-child(4n)) {
  margin-right: calc(20% / 3);
}

.menu-item {
  position: relative;
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
  }
  .item-left {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.search-item {
  padding-top: 20px;
  margin-right: 20px;
  cursor: pointer;
}
</style>